module.exports = __webpack_public_path__ + "static/media/excecute_img.f418aedd.png";